import { IconProps } from '@models/icons';

function LikeFillIcon({
  size = 16, color = '#6E6864', className, ...rest
}: IconProps) {
  return (
      <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
           className={`icon ${className}`}
           {...rest} >
          <circle cx="15" cy="15" r="13.5361" fill={color} stroke="#6E6864" strokeWidth="2"/>
          <path
              d="M18.2793 10.978C18.8305 10.9781 19.3776 11.1863 19.8242 11.5854L20.0088 11.7681C20.4817 12.2927 20.7598 13.0172 20.7598 13.7876C20.7597 14.5452 20.489 15.2565 20.0303 15.7788L15.0918 20.1548L10.1562 15.7808C9.69642 15.2583 9.42489 14.5462 9.4248 13.7876L9.4375 13.4995C9.48904 12.9307 9.69189 12.3987 10.0107 11.9692L10.1807 11.7632C10.596 11.313 11.1239 11.0497 11.6699 10.9907L11.9053 10.978C12.4565 10.978 13.0036 11.1864 13.4502 11.5854L13.6357 11.7681L14.3545 12.5542L15.0928 13.3599L15.8301 12.5542L16.5488 11.7681C17.0243 11.25 17.6492 10.978 18.2793 10.978Z"
              fill="white" stroke="white" strokeWidth="2"/>
      </svg>
  );
}

export default LikeFillIcon;
